(function () {
  const origFetch = window.fetch.bind(window);
  const limitMap = () => (window.themeLimitQtyTo1 = window.themeLimitQtyTo1 || {});
  let skipEnforce = false;
  let cartCache = { items: [] };

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isLimitedProductId(productId) {
    if (!productId) return false;
    const map = limitMap();
    return map[productId] === true || map[String(productId)] === true;
  }

  function markLimited(productId) {
    if (!productId) return;
    limitMap()[productId] = true;
    limitMap()[String(productId)] = true;
  }

  function harvestFromDocument(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-limit-qty-to-1="true"]').forEach((el) => {
      const id = el.getAttribute('data-product-id') || el.getAttribute('data-productid');
      markLimited(id);
    });
  }

  function harvestFromHtml(html) {
    harvestFromDocument(new DOMParser().parseFromString(html, 'text/html'));
  }

  function productIdFromForm(form) {
    if (!form) return null;
    if (form.getAttribute('data-productid')) return form.getAttribute('data-productid');
    const input = form.querySelector('[data-productid]');
    return input ? input.getAttribute('data-productid') : null;
  }

  function formIsLimited(form) {
    if (!form) return false;
    if (form.getAttribute('data-limit-qty-to-1') === 'true') return true;
    return isLimitedProductId(productIdFromForm(form));
  }

  function cartHasProduct(productId) {
    const pid = Number(productId);
    return (cartCache.items || []).some((item) => item.product_id === pid && item.quantity > 0);
  }

  function openCartDrawer() {
    const toggle = document.querySelector('[data-cart-drawer-toggle]');
    if (toggle) toggle.click();
  }

  function refreshCartUi() {
    if (window.cart && typeof window.cart.getCart === 'function') {
      window.cart.getCart();
      return;
    }
    if (document.body.classList.contains('template-cart')) {
      window.location.reload();
    }
  }

  async function loadCartCache() {
    cartCache = await origFetch('/cart.js').then((response) => response.json());
    return cartCache;
  }

  async function enforceLimitQty() {
    if (skipEnforce) return;
    skipEnforce = true;
    try {
      harvestFromDocument(document);
      const cart = await loadCartCache();
      const seen = {};
      const updates = {};

      cart.items.forEach((item) => {
        const pid = String(item.product_id);
        if (!isLimitedProductId(pid)) return;
        if (seen[pid]) {
          updates[item.key] = 0;
          return;
        }
        seen[pid] = true;
        if (item.quantity > 1) {
          updates[item.key] = 1;
        }
      });

      if (Object.keys(updates).length === 0) return;

      await origFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      await loadCartCache();
      refreshCartUi();
    } catch (error) {
      console.error('Limit qty to 1', error);
    } finally {
      skipEnforce = false;
    }
  }

  window.fetch = function (input, init) {
    return origFetch(input, init).then((response) => {
      const url = requestUrl(input);
      const cartMutation = /\/cart\/(add|change|update|clear)/.test(url);
      const cartSection = /section_id=api-cart-items/.test(url);
      if (response.ok && (cartMutation || cartSection)) {
        const clone = response.clone();
        Promise.resolve()
          .then(async () => {
            if (cartSection) {
              harvestFromHtml(await clone.text());
            }
            await enforceLimitQty();
          })
          .catch((error) => console.error('Limit qty to 1', error));
      }
      return response;
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[data-add-to-cart]');
      if (!button) return;
      const form = button.closest('form');
      if (!formIsLimited(form)) return;

      const productId = productIdFromForm(form);
      markLimited(productId);
      form.querySelectorAll('[name="quantity"]').forEach((field) => {
        field.value = '1';
      });

      if (cartHasProduct(productId)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openCartDrawer();
      }
    },
    true
  );

  function init() {
    harvestFromDocument(document);
    loadCartCache().then(() => enforceLimitQty());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
